
import React, {  useEffect, useState, useRef } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
import GMap from './Maps_inserita_nel_form_core';
import { Button} from 'react-bootstrap';
import { BiMapPin } from 'react-icons/bi';

const GOOGLE_MAP_API_KEY = 'AIzaSyBQ-cYUloNXViXO-th1lYveA1iZ2RuStjo';


const Localizzazione_sulla_mappa = (props) => {
    //    const [somma, calcola_somma] = useState('');
    const [loadMap, setLoadMap] = useState(false);
    const [dati_centrali, SET_daticentrali] = useState({lat: 10.0, lng: 10.0});
    const [markerList, SET_markerList] = useState([]);

 

    useEffect(() => {
    loadGoogleMapScript(() => {
        setLoadMap(true)
    });
    }, []);


    const loadGoogleMapScript = (callback) => {
        if (typeof window.google === 'object' && typeof window.google.maps === 'object') {
            callback();
        } else {
            const googleMapScript = document.createElement("script");
    // idroslab      
            googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}`;
            window.document.body.appendChild(googleMapScript);
            googleMapScript.addEventListener("load", callback);
        }
    } 
 
    const centra_immagine = () => {

        var geocoder = new window.google.maps.Geocoder();
        const stringa_indirizzo = props.indirizzo.ditta_indirizzo_via + ' ' + props.indirizzo.ditta_indirizzo_via + ', ' + props.indirizzo.ditta_indirizzo_citta
        geocoder.geocode({address: stringa_indirizzo}, function(results, status) {
          console.log(results[0].geometry.location.lat() + ' - ' + results[0].geometry.location.lng())
          SET_daticentrali ({lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng()})
          SET_markerList ([{lat: results[0].geometry.location.lat(), 
                           lng: results[0].geometry.location.lng(),
                           icon: 'https://cdn2.iconfinder.com/data/icons/IconsLandVistaMapMarkersIconsDemo/256/MapMarker_Marker_Outside_Chartreuse.png',
                           info: '<div><h2>Info 2</h2><p>Lorem Ipsum is simply dummy text<br/> of the printing and typesetting industry.</p></div>',
                           title: "Title 2" }])
    
          if (status == window.google.maps.GeocoderStatus.OK) {
        //        map.setCenter(results[0].geometry.location);
          }
        })
    }



    
    return (
        <> 
        <div className="d-flex flex-column justify-content-center">

            <h4>Sede di stage </h4>
            <Button onClick={() => centra_immagine()}>  <BiMapPin /> 1 Localizzazione tramite indirizzo</Button>
            <small><b>Note:</b> Correggere la posizione con un click del mouse </small>
            {!loadMap ? <div>Loading...</div> : <GMap dati_centrali= {dati_centrali} 
                                                        markerList={markerList} 
                                                        SET_markerList={SET_markerList} />}
            <br/>
                           
                  

        </div>


</>


    )
}
export default Localizzazione_sulla_mappa;